import { render } from "./RankBoard_home.vue?vue&type=template&id=72c62134"
import script from "./RankBoard_home.vue?vue&type=script&lang=js"
export * from "./RankBoard_home.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__